import type { QuickNote } from "../../domain/entities.ts";

export interface QuickNotesState {
  open: boolean;
  notes: QuickNote[];
  activeId: string | null;
  draftId: string | null;
  saveTimer: number | null;
  saving: Promise<void> | null;
  searchOpen: boolean;
  query: string;
  archiveOpen: boolean;
}

export function createQuickNotesState(): QuickNotesState {
  return {
    open: false,
    notes: [],
    activeId: null,
    draftId: null,
    saveTimer: null,
    saving: null,
    searchOpen: false,
    query: "",
    archiveOpen: false,
  };
}
